/**
 * @prop --vx-table-heading-font-size           : The font size of the heading.
 * @prop --vx-table-heading-font-weight         : The font weight of the heading.
 * @prop --vx-table-heading-line-height         : The line height of the heading.
 * @prop --vx-table-heading-margin              : The margin of the heading.
 * @prop --vx-table-heading-text-transform      : The text transformation of the heading (uppercase, ...).
 * @prop --vx-table-row-flex-direction--desktop : The flex direction of the row columns on desktop.
 * @prop --vx-table-row-flex-direction--mobile  : The flex direction of the row columns on mobile.
 * @prop --vx-table-row-gap--desktop            : The flex gap of the row on desktop.
 * @prop --vx-table-row-gap--mobile             : The flex gap of the row on mobile.
 * @prop --vx-table-th-border-bottom            : The bottom border of the table heading.
 * @prop --vx-table-th-font-weight              : The font weight of the table heading.
 * @prop --vx-table-th-text-align               : The text align of the table heading.
 * @prop --vx-table-tr-border-bottom            : The bottom border of the tr.
 * @prop --vx-table-td-font-size                : The font size of the table values.
 * @prop --vx-table-td-font-weight              : The font weight of the table values.
 * @prop --vx-table-td-line-height              : The line height of the table values.
 * @prop --vx-table-td-padding                  : The padding of the table values.
 * @prop --vx-table-td-value-font-weight        : The font weight of the td inner value (nth-child(2)).
 */
:host {
  display: block;
  font-family: sans-serif;
}
:host .heading {
  font-size: var(--vx-table-heading-font-size, 1.25rem);
  font-weight: var(--vx-table-heading-font-weight, bold);
  line-height: var(--vx-table-heading-line-height, 25px);
  margin: var(--vx-table-heading-margin, 16px 0);
  text-transform: var(--vx-table-heading-text-transform, uppercase);
}
:host .row {
  display: flex;
  flex-direction: var(--vx-table-row-flex-direction--desktop, row);
  gap: var(--vx-table-gap--desktop, 16px);
}
:host .row .column {
  flex: 1;
}
@media (max-width: 840px) {
  :host .row {
    flex-direction: var(--vx-table-row-flex-direction--mobile, column);
    gap: var(--vx-table-row-gap--mobile, 0);
  }
}
:host table {
  width: 100%;
}
:host table th, :host table td {
  padding: var(--vx-table-td-padding, 8px 0);
  font-size: var(--vx-table-td-font-size, 1rem);
  line-height: var(--vx-table-td-line-height, 16px);
  width: 50%;
}
:host table th {
  text-align: var(--vx-table-th-text-align, left);
  font-weight: var(--vx-table-th-font-weight, normal);
  border-bottom: var(--vx-table-th-border-bottom, 1px solid #e4e2e2);
}
:host table td {
  font-weight: var(--vx-table-td-font-weight, normal);
}
:host table td:nth-child(2) {
  font-weight: var(--vx-table-td-value-font-weight, bold);
}
:host table tr {
  border-bottom: var(--vx-table-tr-border-bottom, 1px solid #e4e2e2);
  display: flex;
}